/* Shared period-bucketing helpers — pure calc, no UI, no storage
   reads. ISO-week math is duplicated verbatim in ~14 files across this
   codebase (CombinedWeeklySummary.js, BillRegistry.js, etc.) — existing
   copies are left untouched (out of scope to refactor today), but any
   NEW code (starting with the Report Generator) should import from
   here instead of adding a 15th copy. */

/* ISO-8601 week number for a date. Same algorithm already duplicated
   elsewhere in this repo. */
export function getISOWeek(dateStr) {
  if (!dateStr) return null;
  var d = new Date(dateStr + "T00:00:00");
  if (isNaN(d.getTime())) return null;
  var target = new Date(d.valueOf());
  var dayNr = (d.getDay() + 6) % 7;
  target.setDate(target.getDate() - dayNr + 3);
  var firstThursday = target.valueOf();
  target.setMonth(0, 1);
  if (target.getDay() !== 4) target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
  return 1 + Math.ceil((firstThursday - target) / 604800000);
}

/* ISO year for a date — the calendar year can differ from the date's
   own year near Dec 31 / Jan 1 (an ISO week can belong to the
   following/previous year). Needed to build a sortable/unique week
   key. */
export function getISOWeekYear(dateStr) {
  if (!dateStr) return null;
  var d = new Date(dateStr + "T00:00:00");
  if (isNaN(d.getTime())) return null;
  var target = new Date(d.valueOf());
  var dayNr = (d.getDay() + 6) % 7;
  target.setDate(target.getDate() - dayNr + 3);
  return target.getFullYear();
}

/* Sortable/groupable key, e.g. "2026-W38". */
export function getISOWeekKey(dateStr) {
  var wk = getISOWeek(dateStr);
  var yr = getISOWeekYear(dateStr);
  if (wk == null || yr == null) return "";
  return yr + "-W" + String(wk).padStart(2, "0");
}

/* Sortable/groupable key, e.g. "2026-09". */
export function getMonthKey(dateStr) {
  if (!dateStr) return "";
  var d = new Date(dateStr + "T00:00:00");
  if (isNaN(d.getTime())) return "";
  return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0");
}

var MONTH_NAMES = {
  en: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  es: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
};

/* Human label for a groupKey produced by getISOWeekKey/getMonthKey —
   "Sem 38, 2026" / "Septiembre 2026". `seasonLabel` is passed in by
   the caller (resolved via seasonFilter.js's loadSeasons, this file
   never reads storage). */
export function formatPeriodLabel(groupKey, groupBy, lang) {
  if (!groupKey) return lang === "es" ? "Sin fecha" : "No date";
  if (groupBy === "week") {
    var parts = groupKey.split("-W");
    return (lang === "es" ? "Sem " : "Wk ") + parts[1] + ", " + parts[0];
  }
  if (groupBy === "month") {
    var mp = groupKey.split("-");
    var idx = parseInt(mp[1], 10) - 1;
    var names = MONTH_NAMES[lang] || MONTH_NAMES.en;
    return (names[idx] || mp[1]) + " " + mp[0];
  }
  return groupKey;
}
